import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SettingsService } from '../../e-commerce/settings/settings.service';
import { CountriesService } from 'src/app/builder-services/countries/countries.service';
import { VendorService } from 'src/app/multivendor/vendor.service';
import { AppSettingsService } from '../../settings/services/app-settings.service';
import { BuilderService } from 'src/app/builder-services/builder.service';
import { SearchSelectOption } from 'src/app/shared/components/search-select/search-select.component';

interface DropDownList {
  code: string;
  symbol: string;
  name: string;
}

interface Settings {
  currency?: string;
  currency_symbol?: string;
  countryOptions?: string;
  estimatedDeliveryTime?: string;
  estimatedDeliveryUnit?: string;
  hideOutStockProduct?: boolean;
  showProductStock?: boolean;
  useVariantImageAsMain?: boolean;
  selectedCountries?: string[];
  countryNumber?: string;
  companyCountry?: string;
  defaultCountry?: string;
  enableGoogleMaps?: boolean;
  showArea?: boolean;
  showInstagram?: boolean;
  showFacebook?: boolean;
  showPhoneNumber?: boolean;
  showCountry?: boolean;
  meta_pixel_id?: string;
  meta_client_token?: string;
  facebook_displayName?: string;
  allowUpload: boolean;
  enableOrderEmail?: boolean;
  emailTemplate?: string;
  emailSubject?: string;
  emailSignature?: string;
  senderEmail?: string;
  emailLanguage?: string;
  enableOrderBooking?: boolean;
  orderBooking?: {
    day: string;
    value: number;
    from: string;
    to: string;
    state: string;
  }[];
  shippingOption?: string;
  initial_order_status?: string; 
}

@Component({
  selector: 'app-commerce-orders',
  templateUrl: './commerce-orders.component.html',
  styleUrls: ['./commerce-orders.component.scss']
})
export class CommerceOrdersComponent implements OnInit {
  settingsForm: FormGroup;
  settings: Settings = { allowUpload: false };
  countries: any[] = [];
  scheduleData: any[] = [];
  settingsProgress = false;
  contentSettingsData: any = {};

  CurrencyList: DropDownList[] = [
    // U+20C3 UAE DIRHAM SIGN (Unicode 18.0). Written as n escape because the raw
    // glyph is a combining mark that renders onto the preceding character in editors.
    { symbol: '\u20C3', code: 'AED', name: 'United Arab Emirates Dirham' },
    { symbol: '؋', code: 'AFN', name: 'Afghan Afghani' },
    { symbol: 'ل.ل', code: 'LBP', name: 'Lebanese Pound' },
    { symbol: 'د.ت', code: 'TND', name: 'Tunisian Dinar' },
    { symbol: 'ل.س', code: 'ل.س', name: 'Syrian Pound' },
    { symbol: '$', code: 'ARS', name: 'Argentine Peso' },
    { symbol: '$', code: 'AUD', name: 'Australian Dollar' },
    { symbol: 'B$', code: 'BSD', name: 'Bahamian Dollar' },
    { symbol: 'BZ$', code: 'BZD', name: 'Belize Dollar' },
    { symbol: 'R$', code: 'BRL', name: 'Brazilian Real' },
    { symbol: '$', code: 'CLP', name: 'Chilean Peso' },
    { symbol: '$', code: 'COP', name: 'Colombian Peso' },
    { symbol: '$', code: 'MXN', name: 'Mexican Peso' },
    { symbol: '$', code: 'TTD', name: 'Trinidad and Tobago Dollar' },
    { symbol: '₣', code: 'CHF', name: 'Swiss Franc' },
    { symbol: '£', code: 'GBP', name: 'British Pound Sterling' },
    { symbol: 'KM', code: 'BAM', name: 'Bosnia and Herzegovina Convertible Mark' },
    { symbol: '₸', code: 'KZT', name: 'Kazakhstani Tenge' },
    { symbol: 'сом', code: 'KGS', name: 'Kyrgyzstani Som' },
    { symbol: 'د.ع', code: 'IQD', name: 'Iraqi Dinar' },
    { symbol: 'ر.ي', code: 'YER', name: 'Yemeni Rial' },
    { symbol: 'ر.ق', code: 'QAR', name: 'Qatari Riyal' },
    { symbol: 'د.ب', code: 'BHD', name: 'Bahrain Dinar' },
    { symbol: 'сўм', code: 'UZS', name: 'Uzbekistani Som' },
    { symbol: 'ر.س', code: 'SDG', name: 'Sudanese Pound' },
    { symbol: 'Sh', code: 'KES', name: 'Kenyan Shilling' },
    { symbol: 'USh', code: 'UGX', name: 'Ugandan Shilling' },
    { symbol: 'د.ج', code: 'DZD', name: 'Algerian Dinar' },
    { symbol: 'Fr', code: 'RWF', name: 'Rwandan Franc' },
    { symbol: '₵', code: 'GHS', name: 'Ghanaian Cedi' },
    { symbol: 'CFA', code: 'XOF', name: 'West African CFA Franc' },
    { symbol: 'CFA', code: 'XAF', name: 'Central African CFA Franc' },
    { symbol: '$', code: 'NZD', name: 'New Zealand Dollar' },
    { symbol: '$', code: 'FJD', name: 'Fijian Dollar' },
    { symbol: 'K', code: 'PGK', name: 'Papua New Guinean Kina' },
    { symbol: '₼', code: 'AZN', name: 'Azerbaijani Manat' },
    { symbol: 'лв', code: 'BGN', name: 'Bulgarian Lev' },
    { symbol: '৳', code: 'BDT', name: 'Bangladeshi Taka' },
    { symbol: 'Br', code: 'BYN', name: 'Belarusian Ruble' },
    { symbol: '៛', code: 'KHR', name: 'Cambodian Riel' },
    { symbol: '$', code: 'CAD', name: 'Canadian Dollar' },
    { symbol: '₡', code: 'CRC', name: 'Costa Rican Colón' },
    { symbol: 'kn', code: 'HRK', name: 'Croatian Kuna' },
    { symbol: 'Kč', code: 'CZK', name: 'Czech Koruna' },
    { symbol: 'kr', code: 'DKK', name: 'Danish Krone' },
    { symbol: 'RD$', code: 'DOP', name: 'Dominican Peso' },
    { symbol: 'EGP', code: 'EGP', name: 'Egyptian Pound' },
    { symbol: '¢', code: 'GHS', name: 'Ghanaian Cedi' },
    { symbol: 'Q', code: 'GTQ', name: 'Guatemalan Quetzal' },
    { symbol: 'L', code: 'HNL', name: 'Honduran Lempira' },
    { symbol: 'Ft', code: 'HUF', name: 'Hungarian Forint' },
    { symbol: 'Rp', code: 'IDR', name: 'Indonesian Rupiah' },
    { symbol: '₪', code: 'ILS', name: 'Israeli New Shekel' },
    { symbol: '₹', code: 'INR', name: 'Indian Rupee' },
    { symbol: '¥', code: 'JPY', name: 'Japanese Yen' },
    { symbol: '₩', code: 'KRW', name: 'South Korean Won' },
    { symbol: '₭', code: 'LAK', name: 'Lao Kip' },
    { symbol: '₨', code: 'LKR', name: 'Sri Lankan Rupee' },
    { symbol: 'ден', code: 'MKD', name: 'Macedonian Denar' },
    { symbol: 'RM', code: 'MYR', name: 'Malaysian Ringgit' },
    { symbol: '₮', code: 'MNT', name: 'Mongolian Tugrik' },
    { symbol: '₨', code: 'NPR', name: 'Nepalese Rupee' },
    { symbol: '₦', code: 'NGN', name: 'Nigerian Naira' },
    { symbol: 'kr', code: 'NOK', name: 'Norwegian Krone' },
    { symbol: '﷼', code: 'OMR', name: 'Omani Rial' },
    { symbol: 'S/', code: 'PEN', name: 'Peruvian Sol' },
    { symbol: '₱', code: 'PHP', name: 'Philippine Peso' },
    { symbol: 'zł', code: 'PLN', name: 'Polish Złoty' },
    { symbol: 'lei', code: 'RON', name: 'Romanian Leu' },
    { symbol: '₽', code: 'RUB', name: 'Russian Ruble' },
    { symbol: '﷼', code: 'SAR', name: 'Saudi Riyal' },
    { symbol: 'Дин.', code: 'RSD', name: 'Serbian Dinar' },
    { symbol: '₨', code: 'PKR', name: 'Pakistani Rupee' },
    { symbol: '₡', code: 'SCR', name: 'Seychellois Rupee' },
    { symbol: 'kr', code: 'SEK', name: 'Swedish Krona' },
    { symbol: '₺', code: 'TRY', name: 'Turkish Lira' },
    { symbol: '$', code: 'USD', name: 'United States Dollar' },
    { symbol: '₴', code: 'UAH', name: 'Ukrainian Hryvnia' },
    { symbol: '₫', code: 'VND', name: 'Vietnamese Dong' },
    { symbol: 'R', code: 'ZAR', name: 'South African Rand' },
    { symbol: 'Z$', code: 'ZWL', name: 'Zimbabwean Dollar' },
    { symbol: '€', code: 'EUR', name: 'Euro' },
    { symbol: 'د.م.', code: 'DH', name: 'Moroccan Dirham' },
    { symbol: 'د.ك', code: 'KWD', name: 'Kuwaiti Dinar' }
  ];

  // Options for the searchable Currency / Company Country / Default Country fields.
  currencyOptions: SearchSelectOption[] = this.CurrencyList.map((c) => ({ value: c.code, label: `${c.code} (${c.symbol})`, search: c.name }));
  companyCountryOptions: SearchSelectOption[] = [];
  defaultCountryOptions: SearchSelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private settingService: SettingsService,
    private countriesService: CountriesService,
    public vendor: VendorService,
    private appSettingsService: AppSettingsService,
    public builderService: BuilderService,
  ) {
    this.settingsForm = this.fb.group({
      currency: [''],
      companyCountry: [''],
      countryOptions: ['all'],
      selectedCountries: [[]],
      countryNumber: [''],
      defaultCountry: [''],
      estimatedDeliveryUnit: [''],
      estimatedDeliveryTime: [''],
      hideOutStockProduct: [false],
      showProductStock: [false],
      shippingOption: ['show'],
      initial_order_status: [''], // Added field
      useVariantImageAsMain: [false],
      enableGoogleMaps: [false],
      showCountry: [true],
      showArea: [true],
      showInstagram: [false],
      showFacebook: [false],
      showPhoneNumber: [false],
      allowUpload: [false],
      enableOrderEmail: [false],
      enableOrderBooking: [false],
      
      // Email Fields
      emailTemplate: [''],
      emailSubject: [''],
      emailSignature: [''],
      senderEmail: [''],
      emailLanguage: ['en'],
    });
  }

  ngOnInit(): void {
    this.countries = this.countriesService.getCountries();
    this.companyCountryOptions = this.countries.map((c) => ({ value: c.code, label: `${c.emoji} ${c.name}` }));
    this.defaultCountryOptions = this.countries.map((c) => ({ value: c.dial_code, label: `${c.emoji} ${c.name} (${c.dial_code})` }));
    this.loadSettings();
    this.initialStatusLoad();
  }

  loadSettings(): void {
    this.settingService.getSettings().subscribe((settings: Settings) => {
      const effectiveSettings = settings || {};
    const applyPatch = (companyCountry: string) => {
      this.settingsForm.patchValue({
        currency: effectiveSettings.currency || 'AED',
        companyCountry,
        countryOptions: effectiveSettings.countryOptions || 'all',
        selectedCountries: effectiveSettings.selectedCountries || [],
        countryNumber: effectiveSettings.countryNumber || '+971',
        defaultCountry: effectiveSettings.defaultCountry || '',
        estimatedDeliveryTime: effectiveSettings.estimatedDeliveryTime || '',
        estimatedDeliveryUnit: effectiveSettings.estimatedDeliveryUnit || 'minutes',
        hideOutStockProduct: effectiveSettings.hideOutStockProduct || false,
        showProductStock: effectiveSettings.showProductStock || false,
        shippingOption: effectiveSettings.shippingOption || 'show',
        useVariantImageAsMain: effectiveSettings.useVariantImageAsMain || false,
        enableGoogleMaps: effectiveSettings.enableGoogleMaps || false,
        showArea: effectiveSettings.showArea !== undefined ? effectiveSettings.showArea : true,
        showCountry: effectiveSettings.showCountry !== undefined ? effectiveSettings.showCountry : true,
        showInstagram: effectiveSettings.showInstagram || false,
        showFacebook: effectiveSettings.showFacebook || false,
        showPhoneNumber: effectiveSettings.showPhoneNumber || false,
        allowUpload: effectiveSettings.allowUpload || false,
        enableOrderEmail: effectiveSettings.enableOrderEmail || false,
        enableOrderBooking: effectiveSettings.enableOrderBooking || false,
        initial_order_status: effectiveSettings.initial_order_status || 'Pending',
        emailTemplate: effectiveSettings.emailTemplate || `Hello,\n\nWe’re happy to let you know that your order placed on {{orderDate}} has been received and is being processed.\n\nOrder Details:\n- Status: {{orderStatus}}\n- Total: {{totalAmount}}\n\nYour downloads:\n{{downloadLinks}}\n\nIf you need anything, just reach out to our support team.\n\nBest regards,\n{{emailSignature}}`,
        emailSubject: effectiveSettings.emailSubject || `We've received your order #{{orderId}} – Thank you from {{appName}}!`,
        emailSignature: effectiveSettings.emailSignature || `The {{appName}} Team`,
        senderEmail: effectiveSettings.senderEmail || '',
        emailLanguage: effectiveSettings.emailLanguage || 'en',
      });
      this.settings = effectiveSettings;
    };

    if (effectiveSettings.companyCountry) {
      applyPatch(effectiveSettings.companyCountry);
    } else {
      const projectId = String(this.builderService.getSelectedProject());
      this.builderService.getProjectMetadataValue(projectId, 'country').subscribe((metaCountry) => {
        const country = metaCountry || 'EG';
        applyPatch(country);
        // Backfill old projects that have project_metadata.country but no commerce_settings.companyCountry
        this.settingService.submitSettings({ companyCountry: country }).subscribe();
      });
    }
    });
  }

  initialStatusLoad() {
    let project_id = this.builderService.getSelectedProject();
    this.appSettingsService.getContentSettings(project_id).subscribe(
      (settings: any) => {
        this.contentSettingsData = settings !== null ? settings : {};
        if (settings !== null) {
          this.settingsForm.patchValue({ initial_order_status: settings.initial_order_status || 'Pending' });
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  onScheduleChange(schedule: any[]): void {
    this.scheduleData = schedule;
  }

  /*
    Resolves the display glyph for an ISO code from CurrencyList. Falls back to the
    code itself so an unmapped currency still renders something meaningful.
  */
  private getSymbolForCode(code: string): string {
    const match = this.CurrencyList.find((currency) => currency.code === code);
    return match?.symbol || code || '';
  }

  saveSettings(): void {
    this.settingsProgress = true
    const formValue = this.settingsForm.value
    // 1. Save general settings
    this.settings = {
      ...this.settings, // Keep existing values
      currency: formValue.currency,
      currency_symbol: this.getSymbolForCode(formValue.currency),
      companyCountry: formValue.companyCountry,
      countryOptions: formValue.countryOptions || 'all',
      selectedCountries: formValue.selectedCountries,
      countryNumber: formValue.countryNumber,
      defaultCountry: formValue.defaultCountry,
      estimatedDeliveryTime: formValue.estimatedDeliveryTime,
      estimatedDeliveryUnit: formValue.estimatedDeliveryUnit,
      hideOutStockProduct: formValue.hideOutStockProduct,
      showProductStock: formValue.showProductStock,
      useVariantImageAsMain: formValue.useVariantImageAsMain,
      enableGoogleMaps: formValue.enableGoogleMaps,
      showCountry: formValue.showCountry,
      showArea: formValue.showArea,
      showInstagram: formValue.showInstagram,
      showFacebook: formValue.showFacebook,
      showPhoneNumber: formValue.showPhoneNumber,
      allowUpload: formValue.allowUpload,
      enableOrderBooking: formValue.enableOrderBooking,
      enableOrderEmail: formValue.enableOrderEmail,
      shippingOption: formValue.shippingOption,
      emailTemplate: formValue.emailTemplate,
      emailSubject: formValue.emailSubject,
      emailSignature: formValue.emailSignature,
      senderEmail: formValue.senderEmail,
      emailLanguage: formValue.emailLanguage
    }

    if (formValue.enableOrderBooking && this.scheduleData?.length) {
      this.settings.orderBooking = this.scheduleData
    }
    
    this.settingService.submitSettings(this.settings).subscribe({
      next: () => {
        // 2. Save email template
        const emailForm = {
          enableOrderEmail: formValue.enableOrderEmail || false,
          emailTemplate: formValue.emailTemplate || '',
          emailSubject: formValue.emailSubject || '',
          emailSignature: formValue.emailSignature || '',
          senderEmail: formValue.senderEmail || '',
          emailLanguage: formValue.emailLanguage || 'en'
        }
        this.settingService.saveEmailTemplate(emailForm).subscribe({
          next: () => {
            // 3. Save content settings (Initial Order Status)
            let newSubmittedData: any = { ...this.contentSettingsData }
            newSubmittedData['initial_order_status'] = formValue.initial_order_status

            this.appSettingsService.setContentSettings(this.builderService.selectedProject, newSubmittedData).subscribe({
              next: () => {
                if (this.vendor.isMultiVendor) {
                  this.vendor.syncSuperVendorSettingsToVendors()
                }
                this.settingsProgress = false
              },
              error: () => {
                this.settingsProgress = false
              }
            })
          },
          error: () => {
            this.settingsProgress = false
          }
        })
      },
      error: () => {
        this.settingsProgress = false
      }
    })
  }
    // Format country number
  startWithPlus(event: Event): void {
    const input = (event.target as HTMLInputElement).value
    const numericInput = input.replace(/\D/g, '')
    this.settingsForm.get('countryNumber')?.setValue(input.startsWith('+') ? `+${numericInput}` : `+${numericInput}`)
  }
}
